import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GeneralContextComponent } from './general-context.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [
        GeneralContextComponent,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
    ],
    exports: [
        GeneralContextComponent,
    ]
})
export class GeneralContextModule { }
